export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/pop.8124d7f.svg";